import { FormSectionAccordion, FormSectionAccordionProps } from 'components/accordion/FormSectionAccordion'
import { ReactNode } from 'react'
import { useChildFieldErrors } from 'view/cidadao/create/hooks/useChildFieldErrors'

interface Props extends Omit<FormSectionAccordionProps, 'hasError'> {
  children: ReactNode
}

export const FormSectionAccordionWithErrors = ({ children, ...restProps }: Props) => {
  const { hasError } = useChildFieldErrors(children)

  return (
    <FormSectionAccordion {...restProps} hasError={hasError}>
      {children}
    </FormSectionAccordion>
  )
}
